// src/features/cart/api/getMyCart.js
import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getMyCart = () => {
  return axios.get('/cart/my');
};

export const useMyCart = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['cart'],
    queryFn: getMyCart,
  });
};
